"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function findClosestDomain(opts) {
  var domain = opts.domain,
      domains = opts.domains,
      distanceFunction = opts.distanceFunction,
      threshold = opts.threshold;
  var dist;
  var minDist = Infinity;
  var closestDomain = null;

  if (!domain || !domains) {
    return undefined;
  }

  for (var i = 0; i < domains.length; i++) {
    if (domain === domains[i]) {
      return domain;
    }

    dist = distanceFunction(domain, domains[i]);

    if (dist < minDist) {
      minDist = dist;
      closestDomain = domains[i];
    }
  }

  if (minDist <= threshold && closestDomain !== null) {
    return closestDomain;
  } else {
    return undefined;
  }
}

exports.default = findClosestDomain;